// React imports
import React, { useEffect, useState } from 'react'

// Util imports
import InputTextField from '../../common/form-elements/InputTextField'
import { ChannelCreationFormErrorState, ChannelDetailsType } from '../../../lib/types/settings'
import { initialFormErrorState } from '../../../assets/SettingsConfig'
import { defaultErrorState } from 'src/assets/DiscountsConfig'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ChannelCreationFormProps {
  channelDetails: ChannelDetailsType | undefined
  setChannelDetails: React.Dispatch<React.SetStateAction<ChannelDetailsType | undefined>>
  formErrors: ChannelCreationFormErrorState
  setFormErrors: React.Dispatch<React.SetStateAction<ChannelCreationFormErrorState>>
}

const ChannelCreationForm: React.FC<ChannelCreationFormProps> = ({
  channelDetails,
  setChannelDetails,
  formErrors,
  setFormErrors
}) => {
  return (
    <div className='flex flex-col gap-4 w-full'>
      <InputTextField
        label='Channel name'
        textFieldId='channel-name'
        inputType='text'
        inputMargin={'none'}
        isFullWidth={true}
        errorStatus={formErrors?.name?.status}
        errorMessage={'Channel name can not be empty'}
        isRequired={true}
        inputValue={channelDetails?.name}
        handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setChannelDetails((oldValues: any) => ({ ...oldValues, ...{ name: event.target.value } }))
        }
        handleFocus={() =>
          setFormErrors((oldValues: ChannelCreationFormErrorState) => ({
            ...oldValues,
            ...{ name: defaultErrorState }
          }))
        }
      />
      <InputTextField
        label='Channel description (Optional)'
        textFieldId='channel-description'
        inputType='text'
        inputMargin={'none'}
        isFullWidth={true}
        inputValue={channelDetails?.description}
        handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setChannelDetails((oldValues: any) => ({ ...oldValues, ...{ description: event.target.value } }))
        }
      />
    </div>
  )
}

export default ChannelCreationForm
